const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "UserName",
		label: "用户名",
		columnwidth: 150,
	},
	{
		prop: "TrueName",
		label: "姓名",
		columnwidth: 150,
	},
	{
		prop: "KeyCode",
		label: "档案号",
		columnwidth: 150,
	},
	{
		prop: "OperationName",
		label: "操作名称",
		columnwidth: 200,
	},
	{
		prop: "OperateTime",
		label: "操作时间",
		columnwidth: 200,
	},
	{
		prop: "RecordName",
		label: "操作档案号",
		columnwidth: 460,
	},

]

export default headerData;